<template>
    <div id="app">
        <page-header></page-header>
        <main>
            <router-view/>
            <help></help>
        </main>
        <page-footer></page-footer>
    </div>
</template>

<script>
    import Help from '@/components/Help.vue'
    import PageHeader from '@/components/Header.vue'
    import PageFooter from '@/components/Footer.vue'

    export default {
        components: {
            Help,
            PageHeader,
            PageFooter,
        },
        mounted() {
            if(this.$route.name !== 'home' && process.env.NODE_ENV !== 'development') {
                this.$router.push({name: 'home'})
            }
        }
    }
</script>

<style lang="scss">
    @import "assets/scss/style.scss";
</style>
